import { produce } from 'immer';

import { getDictionary } from '../actions/dictionary';

const initialState = {
  dictionary: {},
  loading: false,
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    case getDictionary.types.START:
      state.loading = true;
      return state;

    case getDictionary.types.SUCCESS:
      state.loading = false;
      state.dictionary = action.payload.data;
      return state;

    case getDictionary.types.FAIL:
      state.loading = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
